import { render, staticRenderFns } from "./DebugInfo.vue?vue&type=template&id=3b563d46&scoped=true&"
import script from "./DebugInfo.vue?vue&type=script&lang=js&"
export * from "./DebugInfo.vue?vue&type=script&lang=js&"
import style0 from "./DebugInfo.vue?vue&type=style&index=0&id=3b563d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b563d46",
  null
  
)

export default component.exports